import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function EmailConnectedChart() {
	const emailConnectedChartQuery = api.analytics.emailConnectedChart.useQuery(
		{},
	)

	return (
		<AnalyticsChart
			title="Email Connected"
			data={emailConnectedChartQuery.data}
			isLoading={emailConnectedChartQuery.isLoading}
		/>
	)
}
